export default __webpack_public_path__ + "static/media/Logonz-light.456270bc.svg";